module.exports = __webpack_public_path__ + "media/images/mute-ddba9dee4187ca4eae429490cff475163f306d15f7e5ab87cde7a35e08656877.svg";